import React from 'react'
import './index.css';
import Property7 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property7 num="+91-2934572" type="Family Rustic Cabin" desc="Come and enjoy the experience of a family rustic cabin with your group. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Help the bachelor in his studies and the school-college life to make if smooth and easy." price = "0" guests="8" bed="4"  bath="4"/>
    </div>
  )
}

export default Property
